
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireCorner as ObiWireCornerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-corner.js';
 
 
 

 
 export const ObiWireCorner = createComponent({
   react: React,
   tagName: 'obi-wire-corner',
   elementClass: ObiWireCornerElement,
   events: {
     
   }
  });
 
 